import type { Sort } from 'generatedTypes/flight/models';

export const sortParamSerializer = (sort?: Sort[]): string =>
    sort?.length
        ? sort.map(sortItem => `sort=${sortItem.field},${sortItem.direction}`).join('&')
        : '';
